import { createSlice } from "@reduxjs/toolkit";

const dealSlice = createSlice({
    name: 'deal',
    initialState: {
        isLoading: false,
        data: null,
        dealActivitiesData: null,
        moduleLookupData: null
    },
    reducers: {
        getDealLogStart: (state) => {
            state.isLoading = true;
            state.data = null;
        },
        getDealLogSuccess: (state, action) => {
            state.data = action?.payload?.dealLogs;
            state.isLoading = false;
        },
        getDealLogFailure: (state, action) => {
            state.isLoading = false;
            state.data = null;
        },
        getDealActivitiesStart: (state) => {
            state.isLoading = true;
            state.dealActivitiesData = null;
        },
        getDealActivitiesSuccess: (state, action) => {
            state.dealActivitiesData = action?.payload?.dealLogs;
            state.isLoading = false;
        },
        getDealActivitiesFailure: (state, action) => {
            state.isLoading = false;
            state.dealActivitiesData = null;
        },
        getModuleLookupStart: (state) => {
            state.isLoading = true;
            state.moduleLookupData = null;
        },
        getModuleLookupSuccess: (state, action) => {
            state.moduleLookupData = action?.payload?.lookups;
            state.isLoading = false;
        },
        getModuleLookupFailure: (state, action) => {
            state.isLoading = false;
            state.moduleLookupData = null;
        }
    }
});

export const {
    getDealLogStart,
    getDealLogSuccess,
    getDealLogFailure,
    getDealActivitiesStart,
    getDealActivitiesSuccess,
    getDealActivitiesFailure,
    getModuleLookupStart,
    getModuleLookupSuccess,
    getModuleLookupFailure
} = dealSlice?.actions;

export default dealSlice?.reducer;